import { Controller } from "react-hook-form";
import './Form.css';
import { TextCss } from "../../components/GlobalCss/TextCss";


interface RadioOption {
    value: string
    label: string
    disabled?: boolean
}

interface CustomRadioProps {
    name: string
    options: RadioOption[]
    defaultValue?: string
    required?: boolean
    disabled?: boolean
    label?: string
    control: any
    error?: string
    className?: string
}

const CustomRadio = ({
    name,
    options,
    defaultValue,
    required = false,
    disabled = false,
    label,
    control,
    error,
    className,
}: CustomRadioProps) => {

    
    return (
        <div className="form-group ">
            {label && (

                <label className={TextCss.black.sub_heading_600_14}>
                    {label }
                    {required && <span className="text-danger ml-1"> *</span>}
                </label>
                

            )}
            <Controller
                name={name}
                control={control}
                rules={{
                    required: required ? `${label || name} is required` : false,
                }}
                render={({ field }) => (
                    <div className="radio-group d-flex align-items-center gap-4">
                        {options.map((option) => (
                            
                            <label
                                key={option.value}
                                className={`radio-container ${disabled || option.disabled ? 'radio-disabled' : ''}`}
                            >
                                <input
                                    type="radio"
                                    value={option.value}
                                    checked={String(field.value) === String(option.value)}
                                    onChange={() => field.onChange(option.value)}
                                    disabled={disabled || option.disabled}
                                    className={`radio-input ${error ? 'is-invalid' : ''}`}
                                />
                                <span
                                    className={`radio-custom ${field.value === option.value ? 'radio-checked' : ''
                                        }`}
                                >
                                    {field.value === option.value && (
                                        <span className="radio-dot"></span>
                                    )}
                                </span>
                                <span className="radio-label">{option.label}</span>
                            </label>
                        ))}
                    </div>
                )}
            />
            {error && <p className="invalid-feedback">{error}</p>}
        </div>



    )
}

export default CustomRadio;